// 이미지 blob 경로 상수

export const ESIM_DEVICE_INFO_IMAGE = '/content/img-contents1-image1.webp' // esim 사용가능기종
export const USIM_DEVICE_INFO_IMAGE = '/content/img-contents1-image1-2.webp' // usim 사용가능기종
